import type { ZoneManagerRef } from "@gettactic/api";
import { useMutation } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { useInvalidateZones } from "../invalidate/useInvalidateZones";

export interface ReplaceZoneManagersVariables {
  zoneId: string;
  managers: ZoneManagerRef[];
}

/** Saves a zone's full manager list in one PUT, then refreshes every zone query. */
export const useReplaceZoneManagersMutation = () => {
  const { apiClient } = useTacticHooks();
  const invalidateZones = useInvalidateZones();

  return useMutation({
    mutationFn: async ({ zoneId, managers }: ReplaceZoneManagersVariables) => {
      const res = await apiClient.zones.replaceManagers(zoneId, managers);
      if (!res.ok || !res.result) {
        throw res;
      }
      return res.result;
    },
    onSuccess: async () => {
      await invalidateZones();
    }
  });
};
